import { useContext } from 'react';
import { RefreshViewContext } from './RefreshViewContext';

export function useRefreshView() {
  const value = useContext(RefreshViewContext);
  if (value === undefined) {
    throw Error('RefreshViewContext is used without Provider');
  }
  return value;
}
